<template>
  <div>
    <div id="map" style="height: 500px; width: 100%"></div>
    <div class="filters">
      <select v-model="selectedType" @change="filterLocations">
        <option value="">Alla</option>
        <option value="rundelsgatan">Rundelsgatan</option>
        <option value="dockplatsen">Dockplatsen</option>
        <option value="florettgatan">Florettgatan</option>
      </select>
    </div>
  </div>
</template>
<script>
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default {
  props: {
    selectedPlaces: {
      type: Array,
      required: true,
    },
    selectedTypesOfBuildings: {
      type: Array,
      required: true,
    },
    minSize: {
      type: String,
    },
    maxSize: {
      type: String,
    },
    objects: {
      type: Array,
      default: () => [
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
      ],
    },
    apiKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      map: null,
      AdvancedMarkerElement: null,
      markers: [],
      advancedMarkers: [],
      locations: [
        {
          id: 1,
          type: "rundelsgatan",
          lat: 55.604981,
          lng: 13.003822,
          title: "Rundelsgatan",
        },
        {
          id: 2,
          type: "dockplatsen",
          lat: 55.607981,
          lng: 13.003822,
          title: "Dockplatsen 12",
        },
        {
          id: 3,
          type: "florettgatan",
          lat: 55.605981,
          lng: 13.003822,
          title: "Florettgatan 14",
        },
      ],
      markerCluster: null,
      selectedType: "",
      currentInfoWindow: null,
      filterObjects: [],
    };
  },
  methods: {
    async initMap() {
      const loader = new Loader({
        apiKey: this.apiKey,
        version: "weekly",
      });

      try {
        const { Map } = await loader.importLibrary("maps");
        const { AdvancedMarkerElement } = await loader.importLibrary("marker");

        this.AdvancedMarkerElement = AdvancedMarkerElement;

        this.map = new google.maps.Map(document.getElementById("map"), {
          zoom: 9,
          mapId: "4a7f481b039dddba",
          clickableIcons: false,
        });
        this.filterObjects = this.objects.filter(this.isValidCoordinate);

        this.addMarkers();
        this.fitMapToMarkers();
        google.maps.event.addListener(this.map, "zoom_changed", () => {
          const currentZoom = this.map.getZoom();
          if (currentZoom >= 16) {
            this.refreshMarkerCluster();
          }
        });
      } catch (error) {
        console.error("Error loading Google Maps");
      }
    },
    isValidCoordinate(obj) {
      return (
        obj.latitude !== null &&
        obj.longitude !== null &&
        obj.latitude !== 0.0 &&
        obj.longitude !== 0.0
      );
    },
    addMarkers() {
      this.clearMarkers();
      this.clearMarkerClusterer();
      this.createMarkerClusterer();
    },

    /**create markers and marker-clusters*/
    createMarkerClusterer() {
      const groupedMarkers = this.groupMarkersByPosition(this.filterObjects);
      const markers = [];
      groupedMarkers.forEach((group, key) => {
        const [lat, lng] = key.split(",").map(Number);
        const count = group.length;
        const markerContent = document.createElement("div");
        let isInfoWindowOpen = false;

        markerContent.className = "custom-cluster";
        markerContent.innerHTML = `<span>${count} </span>`;

        const marker = new this.AdvancedMarkerElement({
          position: { lat, lng },
          map: this.map,
          content: markerContent,
        });
        marker.data = group;

        const infoWindow = new google.maps.InfoWindow();
        // Add an event listener for the close button in the InfoWindow

        google.maps.event.addListener(infoWindow, "closeclick", () => {
          this.currentInfoWindow = null;
          isInfoWindowOpen = false;
        });

        marker.addListener("gmp-click", () => {
          const zoomLevel = this.map.getZoom();
          const minZoomForInfoWindows = 9;

          if (zoomLevel >= minZoomForInfoWindows) {
            if (this.currentInfoWindow) {
              this.currentInfoWindow.close();
            }

            this.currentInfoWindow = infoWindow;

            this.showSlideshow(group);
            this.currentInfoWindow.open(this.map, marker);
            isInfoWindowOpen = true;
          }
        });

        //below hover on marker code can be introduced later if needed

        // // Open on hover

        // marker.addEventListener("mouseover", () => {
        //   if (!isInfoWindowOpen) {
        //     const zoomLevel = this.map.getZoom();
        //     const minZoomForInfoWindows = 12;

        //     if (zoomLevel >= minZoomForInfoWindows) {
        //       if (this.currentInfoWindow) {
        //         this.currentInfoWindow.close();
        //       }
        //       this.currentInfoWindow = infoWindow;
        //       this.currentInfoWindow.open(this.map, marker);

        //       this.showSlideshow(group);
        //     }
        //   }
        // });

        // // Close InfoWindow on mouseout **only if it wasn't clicked**
        // marker.addEventListener("mouseout", () => {
        //   if (!isInfoWindowOpen) {
        //     // Only close if it wasn't clicked
        //     if (this.currentInfoWindow) {
        //       this.currentInfoWindow.close();
        //       this.currentInfoWindow = null;
        //     }
        //   }
        // });

        this.map.addListener("click", () => {
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
            isInfoWindowOpen = false;
          }
        });
        markers.push(marker);
      });
      this.advancedMarkers = markers;
      this.markerCluster = new MarkerClusterer({
        markers: markers,
        map: this.map,
        renderer: {
          render: ({ count, position, markers }) => {
            // Calculate the total number of properties/items in the cluster
            var totalPropertyCount = markers.reduce(function (sum, item) {
              return (
                sum + (item.data && item.data.length ? item.data.length : 0)
              );
            }, 0);
            const clusterMarkerContent = document.createElement("div");
            clusterMarkerContent.className = "custom-cluster";
            clusterMarkerContent.innerHTML = `<span>${totalPropertyCount}</span>`;
            return new this.AdvancedMarkerElement({
              map: this.map,
              position,
              content: clusterMarkerContent,
            });
          },
        },
      });

      this.markerCluster.addListener("click", (event) => {
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }
      });
    },
    /**create single or multiple modal-slide show with object data */
    showSlideshow(group) {
      let currentIndex = 0;

      const updateInfoWindowContent = () => {
        let obj = group[currentIndex];

        // Format size display
        let sizeDisplay = "";
        if (obj.sizeFrom || obj.sizeTo) {
          if (obj.sizeFrom === obj.sizeTo) {
            sizeDisplay = `${obj.sizeFrom} m²`;
          } else if (obj.sizeFrom && obj.sizeTo) {
            sizeDisplay = `${obj.sizeFrom} - ${obj.sizeTo} m²`;
          } else {
            sizeDisplay = `${obj.sizeFrom || obj.sizeTo} m²`;
          }
        }

        // Format workplace display
        let workplaceDisplay = "";
        if (obj.numberOfWorkplaces) {
          workplaceDisplay = obj.numberOfWorkplaces;
        } else if (
          obj.minNumberOfWorkplaces !== undefined &&
          obj.maxNumberOfWorkplaces !== undefined
        ) {
          if (obj.minNumberOfWorkplaces === obj.maxNumberOfWorkplaces) {
            workplaceDisplay = `${obj.minNumberOfWorkplaces}`;
          } else {
            workplaceDisplay = `${obj.minNumberOfWorkplaces} - ${obj.maxNumberOfWorkplaces}`;
          }
        }

        // Format price display
        let priceDisplay = "";
        if (obj.PricePerSquare && obj.PricePerSquare > 0) {
          priceDisplay = `${obj.PricePerSquare.toLocaleString("sv-SE")} DKK/m²`;
        }

        const contentString = `
        <a ${
          obj.url ? `href="${obj.url}"` : ""
        } class="c-object-card c-object-card--info-window">
          <span class="t-visually-hidden">${obj.title}</span>
          <div class="c-object-card__image-wrapper">
            <img
              src="${obj.image ? obj.image.ImgSrc : "/fastighet.png"}"
              alt="${obj.title}"
              class="c-object-card__image"
              loading="eager"
            />
            ${
              obj.premiseType && obj.premiseType.length > 0
                ? `<div class="c-object-card__labels">
                    ${obj.premiseType
                      .slice(0, 2)
                      .map((p, idx) => {
                        const label =
                          typeof p === "string"
                            ? p
                            : p.type || p.display || p.value || "";
                        const icon = p.icon || null;
                        return `<span class="c-object-card__label">
                            ${
                              icon
                                ? `<i class="fa fa-${icon} c-object-card__label-icon" aria-hidden="true"></i>`
                                : `<i class="fa-regular fa-briefcase-blank c-object-card__label-icon" aria-hidden="true"></i>`
                            }
                            <span class="c-object-card__label-text">${label}</span>
                          </span>
                          ${
                            idx === 0 && obj.premiseType.length > 1
                              ? `<span class="c-object-card__label-separator" aria-hidden="true">|</span>`
                              : ""
                          }`;
                      })
                      .join("")}
                  </div>`
                : ""
            }

          </div>

          <div class="c-object-card__content">
            <p class="c-object-card__text">${obj.title}</p>

            ${
              obj.address
                ? `<p class="c-object-card__byline">${obj.address}</p>`
                : ""
            }
            ${
              sizeDisplay || workplaceDisplay || priceDisplay
                ? `<div class="c-object-card__info-boxes">
                    ${
                      sizeDisplay
                        ? `<div class="c-object-card__info-box">
                            <i aria-hidden="true" class="fa-regular fa-ruler c-object-card__info-box-icon"></i>
                            <span class="c-object-card__info-box-text">${sizeDisplay}</span>
                          </div>`
                        : ""
                    }
                    ${
                      workplaceDisplay
                        ? `<div class="c-object-card__info-box">
                            <i aria-hidden="true" class="fa-regular fa-users c-object-card__info-box-icon"></i>
                            <span class="c-object-card__info-box-text">${workplaceDisplay} st</span>
                          </div>`
                        : ""
                    }
                    ${
                      priceDisplay
                        ? `<div class="c-object-card__info-box">
                            <i aria-hidden="true" class="fa-regular fa-building c-object-card__info-box-icon"></i>
                            <span class="c-object-card__info-box-text">${priceDisplay}</span>
                          </div>`
                        : ""
                    }
                  </div>`
                : ""
            }
          </div>
          ${
            group.length > 1
              ? `<div class="c-object-card__carousel">
                  <button class="c-object-card__carousel-btn c-object-card__carousel-btn--prev" id="prevButton" ${
                    currentIndex === 0 ? "disabled" : ""
                  }>
                    <i class="fa-regular fa-arrow-left"></i>
                  </button>
                  <span class="c-object-card__carousel-text">${
                    currentIndex + 1
                  } / ${group.length} lokaler</span>
                  <button class="c-object-card__carousel-btn c-object-card__carousel-btn--next" id="nextButton" ${
                    currentIndex === group.length - 1 ? "disabled" : ""
                  }>
                    <i class="fa-regular fa-arrow-right"></i>
                  </button>
                </div>`
              : ""
          }
        </a>
        `;

        this.currentInfoWindow.setContent(contentString);
        google.maps.event.addListenerOnce(
          this.currentInfoWindow,
          "domready",
          () => {
            // Add close button listener
            const closeBtn = document.getElementById("infoWindowCloseBtn");
            if (closeBtn) {
              closeBtn.addEventListener("click", () => {
                if (this.currentInfoWindow) {
                  this.currentInfoWindow.close();
                  this.currentInfoWindow = null;
                }
              });
            }

            if (group.length > 1) {
              document
                .getElementById("prevButton")
                .addEventListener("click", (event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  currentIndex =
                    (currentIndex - 1 + group.length) % group.length;
                  updateInfoWindowContent();
                });
              document
                .getElementById("nextButton")
                .addEventListener("click", (event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  currentIndex = (currentIndex + 1) % group.length;
                  updateInfoWindowContent();
                });
            }
          },
        );
      };
      updateInfoWindowContent();
    },

    /**before creating markers we group them based on the co-ordinates */
    groupMarkersByPosition(filteredLocations) {
      const groupedMarkers = new Map();

      filteredLocations.forEach((location) => {
        const key = `${location.latitude},${location.longitude}`;

        if (!groupedMarkers.has(key)) {
          groupedMarkers.set(key, []);
        }
        groupedMarkers.get(key).push(location);
      });
      return groupedMarkers;
    },

    refreshMarkerCluster() {
      this.clearMarkerClusterer();
      this.markerCluster = new MarkerClusterer({
        markers: this.advancedMarkers,
        map: this.map,
        renderer: {
          render: ({ count, position, markers }) => {
            // Calculate the total number of properties/items in the cluster
            const totalPropertyCount = markers.reduce(function (sum, item) {
              return (
                sum + (item.data && item.data.length ? item.data.length : 0)
              );
            }, 0);
            const clusterMarkerContent = document.createElement("div");
            clusterMarkerContent.className = "custom-cluster";
            clusterMarkerContent.innerHTML = `<span>${totalPropertyCount}</span>`;
            return new this.AdvancedMarkerElement({
              map: this.map,
              position,
              content: clusterMarkerContent,
            });
          },
        },
      });

      this.markerCluster.addListener("click", (event) => {
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }
      });
    },

    /**center the map based on marker co-ordinates */
    fitMapToMarkers() {
      if (!this.map || this.advancedMarkers.length === 0) return;

      const bounds = new google.maps.LatLngBounds();

      this.advancedMarkers.forEach((marker) => {
        if (marker.position) {
          bounds.extend(marker.position);
        }
      });

      this.map.fitBounds(bounds);

      google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
        let zoom = this.map.getZoom();

        if (zoom < 9) {
          this.map.setZoom(9);
        } else if (zoom > 12) {
          this.map.setZoom(12);
        }
      });
    },

    filterLocations() {
      this.clearMarkers();
      this.clearMarkerClusterer();

      this.filterObjects =
        this.selectedPlaces.length > 0
          ? this.objects.filter((location) =>
              this.selectedPlaces.includes(location.type),
            )
          : this.objects;

      this.addMarkers();
    },
    filterPremiseType() {
      this.clearMarkers();
      this.clearMarkerClusterer();

      this.filterObjects =
        this.selectedTypesOfBuildings.length > 0
          ? this.objects.filter((premiseType) =>
              this.selectedTypesOfBuildings.includes(premiseType.type),
            )
          : this.objects;

      this.addMarkers();
    },
    filterSize() {
      this.clearMarkers();
      this.clearMarkerClusterer();

      this.filterObjects = this.objects;
      if (this.minSize !== "") {
        filteredLocations = this.objects.filter(
          (object) =>
            object.sizeFrom >= parseInt(this.minSize) ||
            object.sizeTo >= parseInt(this.minSize),
        );
      }
      if (this.maxSize !== "") {
        filteredLocations = this.objects.filter(
          (object) =>
            object.sizeTo <= parseInt(this.maxSize) ||
            object.sizeFrom <= parseInt(this.maxSize),
        );
      }

      this.addMarkers();
    },

    clearMarkers() {
      if (this.markers) {
        this.markers.forEach((marker) => {
          marker.setMap(null);
        });
        this.markers = [];
      }
      if (this.advancedMarkers) {
        this.advancedMarkers.forEach((advancedMarker) => {
          advancedMarker.setMap(null);
        });
        this.advancedMarkers = [];
      }
    },
    clearMarkerClusterer() {
      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
        this.markerCluster = null;
      }
    },
  },
  watch: {
    objects: {
      immediate: false,
      handler(newObjects) {
        if (newObjects) {
          this.initMap();
        }
      },
    },
    selectedPlaces() {
      this.filterLocations();
    },
    selectedTypesOfBuildings() {
      this.filterPremiseType();
    },
    minSize() {
      this.filterSize();
    },
    maxSize() {
      this.filterSize();
    },
  },
  mounted() {
    if (this.objects) {
      this.initMap();
    }
  },
};
</script>
